import { put, call, takeEvery, select } from 'redux-saga/effects';
import errorHandler from 'common/errorHandler';
import { Endpoints } from 'services/api';
import * as actions from './actions';


function* getUserNotificationConfigData(api, tenantId) {
    let result = yield call([api, api.get], `${Endpoints.configuration}/api/v1/notifications`);
    return result.data;
}

function* updateUserNotificationConfig(api, updateData) {
    const result = yield call([api, api.put], `${Endpoints.configuration}/api/v1/notifications`, updateData);
    return result.data;
}


export function* getUserNotificationConfigDataRequest(api) {
    try {
        let userNotificationConfigData = [];
        const response = yield call(getUserNotificationConfigData, api);
        if (response.Items) {
            userNotificationConfigData = response.Items;
        }
        yield put(actions.getUserNotificationConfigSuccess(userNotificationConfigData));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "user notification config data");
        yield put(actions.geUserNotificationConfigFailure(errorObject));
    }
}

export function* updateUserNotificationConfigRequest(api, action) {
    const { payload } = action;
    try {
        yield call(updateUserNotificationConfig, api, payload);
        yield put(actions.updateUserNotificationConfigSuccess());
    } catch (error) {
        let errorObject = errorHandler(error, "Update", "user notification config");
        yield put(actions.updateUserNotificationConfigFailure(errorObject));
    }
}


export function* watchGetUserNotificationConfigDataRequest(api, params) {
    yield call(getUserNotificationConfigDataRequest, api);
}

export function* watchUpdateUserNotificationConfigRequest(api, action) {
    yield call(updateUserNotificationConfigRequest, api, action);
}


export default function* ({ api }) {
    yield takeEvery(actions.GET_USER_NOTIFICATION_CONFIG_REQUEST, watchGetUserNotificationConfigDataRequest, api);
    yield takeEvery(actions.UPDATE_USER_NOTIFICATION_CONFIG_REQUEST, watchUpdateUserNotificationConfigRequest, api);
}